import TooltipSeparator from './TooltipSeparator';

export default TooltipSeparator;
